__turbopack_context__.v({
  "bg": "styles-module-scss-module__jJvGKq__bg",
  "bgWrap": "styles-module-scss-module__jJvGKq__bgWrap",
  "buttonFancy": "styles-module-scss-module__jJvGKq__buttonFancy",
  "container": "styles-module-scss-module__jJvGKq__container",
  "cta": "styles-module-scss-module__jJvGKq__cta",
  "ctaImg": "styles-module-scss-module__jJvGKq__ctaImg",
  "logo": "styles-module-scss-module__jJvGKq__logo",
  "rootHeader": "styles-module-scss-module__jJvGKq__rootHeader",
});
